import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FlexModule} from '@Common/widgets/flex-layout/flex/flex.module';
import {MatAngularModule} from '@Common/mat-angular.module';
import {CommonModuleP8} from '@Common/common-p8.module';
import {TreeExtendedModule} from '@Common/widgets/general/tree-extended/tree-extended.module';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonArchivageModule} from '../common/common.module';
import {LoaningRoutingModule} from './loaning-routing.module';
import { LoaningEditComponent } from './loaning-edit/loaning-edit.component';
import { ConsultationComponent } from './consultation/consultation.component';
import {DepositModule} from '../deposit/deposit.module';
import { TakeChargeConsultationComponent } from './consultation/take-charge/take-charge.component';
import { LoaningStateChipComponent } from './loaning-state-chip/loaning-state-chip.component';
import { MyLoaningsComponent } from './my-loanings/my-loanings.component';
import {UploadScanDialogComponent} from "./consultation/files/upload-scan/upload-scan.component";
import {DialoguesComponent} from "./dialogues/dialogues.component";




@NgModule({
  declarations: [
    LoaningEditComponent,
    ConsultationComponent,
    TakeChargeConsultationComponent,
    LoaningStateChipComponent,
    MyLoaningsComponent,
    UploadScanDialogComponent,
    DialoguesComponent
  ],
  imports: [
    FlexModule,
    MatAngularModule,
    CommonModule,
    CommonModuleP8,
    TreeExtendedModule,
    ReactiveFormsModule,
    CommonArchivageModule,
    LoaningRoutingModule,
    DepositModule,
  ],
  exports: [
    ConsultationComponent
  ]
})
export class LoaningModule { }
